import React, { useState, useEffect } from 'react';
import { logger } from '../utils/logger';
import { Link } from 'react-router-dom';
import { Heart, Palette, Award, Sparkles } from 'lucide-react';
import { Card, CardContent } from './ui/card';
import axios from 'axios';
import { OptimizedImage } from './OptimizedImage';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const iconMap = {
  heart: Heart,
  award: Award,
  palette: Palette,
  sparkles: Sparkles
};

export const USPSection = () => {
  const [usps, setUsps] = useState([]);
  
  useEffect(() => {
    fetchUSPs();
  }, []);
  
  const fetchUSPs = async () => {
    try {
      const response = await axios.get(`${API}/cms/usp-items?t=${Date.now()}`);
      setUsps(response.data.sort((a, b) => a.order - b.order));
    } catch (error) {
      logger.error('Error fetching USPs:', error);
    }
  };
  
  return (
    <section className="py-12 bg-white">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {usps.map((usp, index) => {
            const Icon = iconMap[usp.icon_name] || Heart;
            return (
              <Card 
                key={usp.title || `usp-${index}`} 
                className="overflow-hidden border-terra-beige/20 bg-white"
              >
                {/* Image Section */}
                {usp.image_url && (
                  <div className="relative h-64 overflow-hidden">
                    <OptimizedImage
                      src={usp.image_url}
                      alt={usp.title}
                      priority={false}
                      objectFit="cover"
                      className="w-full h-full"
                      sizes="(max-width: 640px) 100vw, (max-width: 1024px) 50vw, 25vw"
                    />
                  </div>
                )}
                
                <CardContent className="pt-6 pb-6 px-6 text-center">
                  <div className="w-16 h-16 bg-terra-beige/10 flex items-center justify-center mx-auto mb-4">
                    <Icon className="w-8 h-8 text-terra-beige" />
                  </div>
                  <h3 className="font-sweet-sans text-lg font-normal text-earth-brown mb-2 uppercase tracking-wide">
                    {usp.title}
                  </h3>
                  <p className="font-sweet-sans text-sm text-almost-black/70 leading-relaxed">
                    {usp.description}
                  </p>
                </CardContent>
              </Card>
            );
          })}
        </div>
        
        {/* CTA Link */}
        <div className="flex justify-center mt-8">
          <Link 
            to="/shop"
            className="text-earth-brown font-sweet-sans text-sm uppercase tracking-wider underline hover:text-earth-brown/70 transition-colors duration-200 font-bold"
          >
            Ontdek de collectie
          </Link>
        </div>
      </div>
    </section>
  );
};